import React, { useState, useEffect } from "react";
import { Text } from "react-internationalization";
import { useSelector, useDispatch } from "react-redux";
import Popup from "reactjs-popup";
import AssignPCP from "../../AssignPCP";
import AutoComplete1 from "../../../Utils/Select";
import { setPcpData } from "../../../Redux/Actions/webAppActions";
import { LANG } from "../../translations/dynamic";
import { SHARP_CONSTS } from "../../../Utils/StaticData/Constant";
const PcpInputs = ({ handleChange, data }) => {
  const [stateFlag, setStateFlag] = useState(false);
  const [pcpName, setPcpName] = useState("");
  const [clinicName, setClinicName] = useState("");
  const [pcpDropdownList, setPcpDropdownList] = useState([]);
  const planType = useSelector((state) => state.webApp.planType);
  const physiciansData = useSelector((state) => state.webApp.physiciansData);
  const pcpSelected = useSelector((state) => state.webApp.selectedVo);
  const preEnrollInfo = useSelector((state) => state.webApp.preEnrollInfo);
  const stateId = useSelector((state) => state.webApp.stateId);
  const language = useSelector((state) => state.webApp.language);
  const pcpSubscription = useSelector((state) => state.login.pcpSubscription);
  const clickedSaveNextIds = useSelector(
    (state) => state.webApp.clickedSaveNextIds
  );
  const customerId = useSelector((st) => st.login.customerId);
  const dispatch = useDispatch();
  useEffect(() => {
    let arr = [];
    //label:element.label,
    //removing select label value from physicians data bcoz its undefined
    let removeKeys = ["---Select---"];
    let filteredphysiciansData = physiciansData.filter(
      (obj) => removeKeys.indexOf(obj.label) === -1
    );
    let ids = [SHARP_CONSTS.SHARP_CUSTOMER_ID];
    if (ids.some((i) => i === customerId)) {
      filteredphysiciansData.forEach((element) => {
        arr.push({
          label: element.doctorName + " - " + element.doctorAddress,
          value: element.doctorName + " - " + element?.locationId,
          acceptNewPatient: element.acceptNewPatient,
        });
      });
    } else {
      filteredphysiciansData.forEach((element) => {
        arr.push({
          label: element.doctorName,
          value: element.doctorName,
        });
      });
    }
    setPcpDropdownList(arr);
  }, [physiciansData]);
  const setFlag = () => {
    setStateFlag(true);
  };

  useEffect(() => {
    if (pcpSelected.pcpName) {
      let ids = [SHARP_CONSTS.SHARP_CUSTOMER_ID];
      if (ids.some((i) => i === customerId)) {
        setPcpName(pcpSelected.pcpName + " - " + pcpSelected.PcpLocationId);
        setClinicName(
          physiciansData.length > 1
            ? physiciansData.filter(
                (data1) =>
                  data1?.doctorName + " - " + data1?.locationId ===
                  pcpSelected?.pcpName + " - " + pcpSelected?.PcpLocationId
              )[0].clinicName
            : preEnrollInfo?.pcpDetails?.name
        );
      } else {
        setPcpName(pcpSelected.pcpName);
        setClinicName(
          physiciansData.length > 1
            ? physiciansData.filter(
                (data1) => data1.doctorName === pcpSelected.pcpName
              )[0].clinicName
            : preEnrollInfo.pcpDetails.name
        );
      }
    } else if (preEnrollInfo.pcpName) {
      let ids = [SHARP_CONSTS.SHARP_CUSTOMER_ID];
      if (ids.some((i) => i === customerId)) {
        setPcpName(preEnrollInfo.pcpName + " - " + preEnrollInfo.locationId);
      } else {
        setPcpName(preEnrollInfo.pcpName);
      }
      setClinicName(preEnrollInfo.clinicName);
    } else {
      setClinicName("");
    }
  }, [pcpSelected, physiciansData]);

  useEffect(() => {
    if (preEnrollInfo.pcpName) {
      let ids = [SHARP_CONSTS.SHARP_CUSTOMER_ID];
      if (ids.some((i) => i === customerId)) {
        setPcpName(preEnrollInfo.pcpName + " - " + preEnrollInfo.locationId);
        setClinicName(
          physiciansData.length > 1
            ? physiciansData.filter(
                (data1) =>
                  data1.doctorName + " - " + data1.locationId ===
                  preEnrollInfo.pcpName + " - " + preEnrollInfo.locationId
              )[0]?.clinicName
            : preEnrollInfo.pcpDetails.name
        );
      } else {
        setPcpName(preEnrollInfo.pcpName);
        setClinicName(
          physiciansData.length > 1
            ? physiciansData.filter(
                (data1) => data1.doctorName === preEnrollInfo.pcpName
              )[0]?.clinicName
            : preEnrollInfo.pcpDetails.name
        );
      }
    } else {
      setClinicName("");
    }
  }, [preEnrollInfo]);

  useEffect(() => {
    isReset();
  }, [data.isCurrentPatient]);

  const isReset = () => {
    setPcpName("");
    setClinicName("");
  };
  const handleDropdown = (name) => (event) => {
    let value = "";
    value = event.target ? event.target.value : event.value || event.label;
    setPcpName(value);
    let ids = [SHARP_CONSTS.SHARP_CUSTOMER_ID];
    let selectedPCP;
    if (ids.some((i) => i === customerId)) {
      selectedPCP = physiciansData.filter(
        (x) => x.doctorName + " " + "-" + " " + x?.locationId === value
      )[0];
    } else {
      selectedPCP = physiciansData.filter((x) => x.doctorName === value)[0];
    }
    let payload;
    if (value === "---Select---") {
      payload = {
        pcpOfficeCd: "",
        PcpLocationId: "",
        pcpName: "",
        pcpCurrPatnt: "",
        pcpNpiId: "",
        pcpAddress: "",
        pcpCity: "",
        pcpState: "",
        pcpZip: "",
        distance: "",
      };
    } else {
      payload = {
        pcpOfficeCd: selectedPCP.providerCode,
        PcpLocationId: selectedPCP.locationId,
        pcpName: selectedPCP.doctorName ? selectedPCP.doctorName : "no",
        pcpCurrPatnt: selectedPCP.currentPatientInd,
        pcpOffCatCd: selectedPCP.providerCategoryCode,
        pcpNpiId: selectedPCP.alternateOfficeCode,
        pcpAddress: selectedPCP.doctorAddress,
        pcpCity: selectedPCP.city,
        pcpState: selectedPCP.stateCode,
        pcpZip: selectedPCP.zipCode,
        distance: selectedPCP.googleApiDistance,
      };
    }
    dispatch(setPcpData(payload));
  };
  return (
    <>
      <div class="row mt-3 mb-3">
        <div class="col-md-6">
          <label for="pcpName" class="control-label">
            <Text id="step2.PCPName" />
            {planType === "HMO" ? "*" : ""}
          </label>
          {pcpSubscription !== "Y" ? (
            <>
              <br />
              <AutoComplete1
                field="pcpName"
                // dashboard="prospect"
                error={
                  clickedSaveNextIds.includes("next2") &&
                  (pcpName === "" ||
                    pcpName ===
                      "---" +
                        (language === "es"
                          ? LANG.COMMON_TEXT.select
                          : "select") +
                        "---")
                }
                handleChange={handleDropdown("pcpName")}
                options={
                  data.isCurrentPatient === "Y"
                    ? pcpDropdownList
                    : pcpDropdownList.filter(
                        (item) => item.acceptNewPatient === "Y"
                      )
                }
                value={
                  pcpDropdownList?.filter((data1) => data1?.value === pcpName)
                    .length !== 0
                    ? pcpDropdownList?.filter(
                        (data1) => data1?.value === pcpName
                      )[0]
                    : {
                        label:
                          language === "es"
                            ? LANG.COMMON_TEXT.select
                            : "select",
                        value: "",
                      }
                }
                defaultValue={{
                  label: language === "es" ? LANG.COMMON_TEXT.select : "select",
                  value: "",
                }}
                name="pcpName"
                height="1.3rem"
              />
            </>
          ) : (
            <>
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                value={pcpName}
                onChange={handleChange}
                disabled="true"
                class={
                  clickedSaveNextIds.includes("next2")
                    ? pcpName !== "" && pcpName !== undefined
                      ? "form-control cursor-not-allowed"
                      : "error-input cursor-not-allowed"
                    : "form-control cursor-not-allowed"
                }
                style={{ marginBottom: "10px" }}
              />
              <div class="m-top-neg15">
                <Popup
                  className={"pcp-popup"}
                  modal
                  trigger={
                    <button class="assign-pcp" id="pcp_popup">
                      <Text id="step4Agent.assignpcp" />
                    </button>
                  }
                  position="right center"
                  repositionOnResize={true}
                  contentStyle={{
                    width: "77% !important",
                    padding: "0px",
                  }}
                >
                  {(close) => (
                    <div>
                      <AssignPCP
                        data={data}
                        setFlag={setFlag}
                        flag={stateFlag}
                        close={close}
                        pcpList={physiciansData.slice(1)}
                        preSelectedPCP={pcpSelected}
                        preEnrollInfo={preEnrollInfo ? preEnrollInfo : ""}
                        stateId={stateId}
                        isReset={isReset}
                        // makePcpEmpty={props.makePcpEmpty}
                      />
                    </div>
                  )}
                </Popup>
              </div>
            </>
          )}
        </div>
        <div class="col-md-6 assign-pcp-margin">
          <label for="pcpMedicalGroupName" class="control-label">
            <Text id="step2.ClinicName" />
            {planType === "HMO" ? "*" : ""}
            {/* :* */}
          </label>
          <input
            autoComplete="off"
            spellcheck="false"
            aria-autocomplete="both"
            aria-haspopup="false"
            type="text"
            id="pcpMedicalGroupName"
            name="pcpMedicalGroupName"
            value={clinicName}
            onChange={handleChange}
            disabled="true"
            class={
              clickedSaveNextIds.includes("next2")
                ? clinicName !== "" && clinicName !== undefined
                  ? "form-control cursor-not-allowed"
                  : "error-input cursor-not-allowed"
                : "form-control cursor-not-allowed"
            }
          />
        </div>
      </div>
    </>
  );
};
export default PcpInputs;
